export interface MateriaInvestigacionDTO{
    codmateria: string, 
    nombremateria: string, 
    codestudiante: string, 
    estado: string,
}

export function VoidMateriaInvestigacionDTO(){
    return{
        codmateria: '', 
        nombremateria: '', 
        codestudiante: '', 
        estado: '',
    }    
}